/**
 * A filter object as URL parameters: blank filters are left off the URL rather
 * than sent as "", which a strict schema would refuse and which reads as
 * "match nothing" rather than "no filter".
 */
export function compactParams(
  params: Record<string, string | number | undefined>,
): Record<string, string | number> {
  const kept: Record<string, string | number> = {};
  for (const [name, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') kept[name] = value;
  }
  return kept;
}
